export const WEEKDAY_NAMES = [
  "Domingo",
  "Lunes",
  "Martes",
  "Miércoles",
  "Jueves",
  "Viernes",
  "Sábado",
];

export const DEFAULT_PAYDAY = 6;

export const dateKey = (value) => String(value || "").slice(0, 10);

export const fmtDay = (value) => {
  const key = dateKey(value);
  if (key.length < 10) return "";
  const [, month, day] = key.split("-");
  return `${day}/${month}`;
};
